import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ClearLocalStorage, getLocalStoragKey, setLocalStorage } from "../../store/mahutiLocalStorage";
import { resetSelections, setLastOrderId } from "../../store/MahutiReducer";
import './PaymentSuccess.css'
import { useLocation } from "react-router-dom";
import { EVENT_IFRAME_BACK, LOCAL_STORAGE_STEP } from "../../utils/GlobalParams";
import { paymentVerify } from "../../utils/api";
import Stack from '@mui/material/Stack';
import LinearProgress from '@mui/material/LinearProgress';

export default function PaymentSuccess() {
    const [orderId, setOrderId] = useState();
    const [error, setError] = useState(false);
    const location = useLocation()

    const setOnloadEvent = (orderIdEvent) => {
        window.parent.postMessage(
            {
                type: 'success-page-onload',
                message: 'success-page-successfully-loaded',
                orderId: orderIdEvent
            },
            '*'
        )
    }

    const backClick = () => {
        window.parent.postMessage(
            {
                type: 'button-click',
                message: EVENT_IFRAME_BACK,
            },
            '*'//TODO: Change to www.mahuti.co.il
        )
    }

    const init = async () => {
        const params = new URLSearchParams(location.search)
        let token = (params.get('Token'));

        token ? paymentVerify(token).then(res => {
            setOrderId(res.data.orderId)
            setOnloadEvent(res.data.orderId)
        })
        .catch(err => {
            console.log(err)
            setError(true)
        }) : setError(true)

        const mainHeader = document.getElementsByClassName('main-header');
        const mainfooter = document.getElementsByClassName('main-footer');
        if(mainfooter.length > 0) document.getElementsByClassName('main-footer').style.display = 'none';
        if (mainHeader.length > 0) document.getElementsByClassName('main-header').style.display = 'none';
        
        //Add event disapcher for parent widnow back function        
       

    }
    useEffect(() => {
        init()
    }, [])

    return (orderId || error) ? <div className="PaymentSuccess">
                                    <div className="content">
                                        <div className="p-3">
                                            <i className="icon-Success" />
                                        </div>
                                        <h1 className="header-cover-title p-3">הזמנתך התקבלה בהצלחה!</h1>

                                        {orderId && !error && <h2 className="text-mahuti p-3"> מס הזמנה: {orderId}</h2>}

                                        {error && !orderId && <h2 className="text-mahuti p-3">ארעה שגיאה בשליחת הקבלה, נא לפנות למוקד</h2>}
                                        
                                        <h2 className="text-mahuti p-3">נתראה בקרוב </h2>
                                        <button id="payment_back" className="btn-primary" onClick={() => backClick()}>חזור</button>

                                    </div>
                                </div> : <LinearProgress className="testt" color='inherit' style={{color: '#F04D81'}} />
}